<template>
  <select
    class="form-select"
    multiple
    :style="'height: ' + (Object.keys(options).length * 1.4375 + 2.25 + 0.125 + 'rem;')"
    :class="{ 'is-invalid': error }"
    :name="name"
    :data-attribute="attribute"
    :disabled="disabled"
    :value="values"
    @click="updateSelect($event)"
  >
    <option v-for="(option, index) in options" :key="index" :value="option.value">
      {{ option.text }}
    </option>
  </select>
</template>

<script>
// import Multiselect from 'vue-multiselect';

export default {
  components: {
    // Multiselect,
  },
  props: {
    name: { type: String, default: '' },
    values: { type: Array, default: () => [] },
    attribute: { type: String, default: '' },
    error: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    options: { type: Object, default: () => {} },
  },
  emits: ['update:data'],
  setup(/*props, { emit }*/) {
    const updateSelect = (/*event*/) => {
      // yeah... this doesn't work - screw you, native html multiselects...
      // stopping here for now... feel free to finish this or scrap it
      // let updateValues;
      //
      // if (props.values.includes(event.target.value)) {
      //   updateValues = props.values.filter((item) => !item === event.target.value);
      // } else {
      //   updateValues = props.values;
      //   updateValues.push(event.target.value);
      // }
      // console.log(event.srcElement);
      // emit('update:data', { target: { value: updateValues } })
    };

    return {
      updateSelect,
    };
  },
};
</script>
